import { render, staticRenderFns } from "./OrgLayout.vue?vue&type=template&id=7a1abae4&scoped=true"
import script from "./OrgLayout.vue?vue&type=script&lang=js"
export * from "./OrgLayout.vue?vue&type=script&lang=js"
import style0 from "./OrgLayout.vue?vue&type=style&index=0&id=7a1abae4&prod&lang=scss"
import style1 from "./OrgLayout.vue?vue&type=style&index=1&id=7a1abae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1abae4",
  null
  
)

export default component.exports